import { useMemo } from "react";

import { cn } from "@/lib/utils";

interface AdditionalDetailsProps {
  additionalDetails: string;
  className?: string;
}

export default function AdditionalDetails({
  additionalDetails,
  className,
}: AdditionalDetailsProps) {
  const additionalDetailsText = useMemo(
    () => additionalDetails.trim(),
    [additionalDetails]
  );

  if (!additionalDetailsText) {
    return null;
  }

  return (
    <div
      className={cn(
        "rounded-[15px] bg-white/5 p-5 md:rounded-[20px] md:px-6",
        className
      )}
    >
      <h4 className="font-medium text-18/[1.2em] text-white">
        Additional details
      </h4>
      <p className="mt-2.5 whitespace-pre-line text-14/[1.71em] text-cool-gray">
        {additionalDetailsText}
      </p>
    </div>
  );
}
